<div class="gb-offline-snack-bar">
  <span matSnackBarLabel>
    <mat-icon>wifi_off</mat-icon>
    <span translate="SHARED.OFFLINE_SNACKBAR.NO_INTERNET_CONNECTION"></span>
  </span>

  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="onReload()" [disabled]="isLoading">
      @if (isLoading) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else {
        <span translate="SHARED.OFFLINE_SNACKBAR.TRY_AGAIN"></span>
      }
    </button>
  </span>
</div>
